module.exports = __webpack_public_path__ + "img/newsImg13-1.88ed93ae.png";